export default function initRegionMap() {
    const regionMaps = document.querySelectorAll(".region-map")

    regionMaps.forEach((regionMap) => {
        if (regionMap.getAttribute("data-init-region-map")) return

        regionMap.setAttribute("data-init-region-map", "true")

        const pinsMap = regionMap.querySelectorAll("[data-action='open-region-map']")
        
        pinsMap.forEach((pin) => {
            if (window.innerWidth < 1024) {
                if (pin.dataset.left < 51) {
                    pin.classList.add("right")
                } else {
                    pin.classList.add("left")
                }

                if (pin.dataset.top < 51) {
                    pin.classList.add("bottom")
                } else {
                    pin.classList.add("top")
                }
            }

            pin.addEventListener("click", () => {
                pinsMap.forEach((item) => {
                    if (item !== pin) {   
                        item.classList.remove("active")
                    }
                })
                
                pin.classList.toggle("active")
            })
        })
    })
}

if (document.querySelector(".region-map")) {
    initRegionMap()
}